module.exports = __webpack_public_path__ + "static/bottom-581e3911c72771ec6cc2604f05d66053.png";